import {applyPriceFormatter, CurrencyConfiguration} from "@next/utils"
import {FacetsState} from "../../models/FacetsState"

import {Filter} from "../../models/Filter"
import {isPriceFilter} from "../../models/Filter/typeGuards"
import {isFilteredPriceFn} from "../getFilterFacets"

interface Params {
    historicFacetFilter: Record<string, string[]>
    filter: Filter
    locale: string
    realm: string
    facets: FacetsState
    globalPriceFormattingConfig: CurrencyConfiguration
}

export const getSelectedFacetFilters = ({
    historicFacetFilter,
    filter,
    locale,
    facets,
    realm,
    globalPriceFormattingConfig,
}: Params): string => {
    if (isPriceFilter(filter) && isFilteredPriceFn(filter)) {
        return applyPriceFormatter({
            minPrice: filter.selectedMin,
            maxPrice: filter.selectedMax,
            realm,
            locale,
            currencyCode: filter.currencyCode,
            globalPriceFormattingConfig,
        }) as string
    }

    let stringToReturn: string[] = []

    Object.entries(historicFacetFilter).forEach(([key, values]) => {
        if (filter.name === key) {
            stringToReturn = values.map(value => facets[value].n)
        }
    })

    return stringToReturn.join(", ")
}
